import { WebsitePageContent } from "../interfaces/WebsiteBlock";
import { WebsiteFormOption, WebsitePage } from "../interfaces/WebsitePage";

export const getWebsitePagesInitAction = () => ({ type: "[WebsitePage] Get Pages Init" as const });
export const getWebsitePagesSuccessAction = (payload: { pages: WebsitePage[] }) => ({
  type: "[WebsitePage] Get Pages Success" as const,
  payload,
});
export const getWebsitePagesFailureAction = (payload: { error: unknown }) => ({
  type: "[WebsitePage] Get Pages Failure" as const,
  payload,
});

export const getWebsitePageInitAction = () => ({ type: "[WebsitePage] Get Page Init" as const });
export const getWebsitePageSuccessAction = (payload: { page: WebsitePage }) => ({
  type: "[WebsitePage] Get Page Success" as const,
  payload,
});
export const getWebsitePageFailureAction = (payload: { error: unknown }) => ({
  type: "[WebsitePage] Get Page Failure" as const,
  payload,
});

export const postWebsitePageSuccessAction = (payload: { page: WebsitePage }) => ({
  type: "[WebsitePage] Post Page Success" as const,
  payload,
});

export const putWebsitePageSuccessAction = (payload: { page: WebsitePage }) => ({
  type: "[WebsitePage] Put Page Success" as const,
  payload,
});

export const deleteWebsitePageSuccessAction = (payload: { pageId: string }) => ({
  type: "[WebsitePage] Delete Page Success" as const,
  payload,
});

export const getWebsiteFormsSuccessAction = (payload: { forms: WebsiteFormOption[] }) => ({
  type: "[WebsitePage] Get Forms Success" as const,
  payload,
});

export const setEditorContentAction = (payload: { contentJson: WebsitePageContent }) => ({
  type: "[WebsitePage] Set Editor Content" as const,
  payload,
});

export const setSelectedBlockAction = (payload: { blockId: string | null }) => ({
  type: "[WebsitePage] Set Selected Block" as const,
  payload,
});

export const setEditorViewModeAction = (payload: { viewMode: "desktop" | "tablet" | "mobile" }) => ({
  type: "[WebsitePage] Set View Mode" as const,
  payload,
});

export type WebsitePageApiAction =
  | ReturnType<typeof getWebsitePagesInitAction>
  | ReturnType<typeof getWebsitePagesSuccessAction>
  | ReturnType<typeof getWebsitePagesFailureAction>
  | ReturnType<typeof getWebsitePageInitAction>
  | ReturnType<typeof getWebsitePageSuccessAction>
  | ReturnType<typeof getWebsitePageFailureAction>
  | ReturnType<typeof postWebsitePageSuccessAction>
  | ReturnType<typeof putWebsitePageSuccessAction>
  | ReturnType<typeof deleteWebsitePageSuccessAction>
  | ReturnType<typeof getWebsiteFormsSuccessAction>
  | ReturnType<typeof setEditorContentAction>
  | ReturnType<typeof setSelectedBlockAction>
  | ReturnType<typeof setEditorViewModeAction>;
